import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterComponent } from './filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';


@NgModule({
  declarations: [FilterComponent],
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  exports: [FilterComponent],
})
export class FilterModule {}
